export default __webpack_public_path__ + "static/media/regulatory--no-straight-through--g2.9e890383.png";